import { z } from 'zod'

/**
 * What a document IS, which is separate from what it is attached to.
 *
 * The distinction that matters for proposals: a SITE_MAP is a drawing of this
 * client's own site, while EXAMPLE_WORK is a map or photo from a past job that
 * gets reused in a templated first proposal. Both are files attached to a
 * proposal; only one of them is about the recipient.
 *
 * Mirrors `DocumentKind` in prisma/schema.prisma.
 */
export const DOCUMENT_KINDS = [
  'SITE_MAP',
  'EXAMPLE_WORK',
  'PHOTO',
  'CONTRACT',
  'LOGO',
  'OTHER',
] as const

export const documentKindSchema = z.enum(DOCUMENT_KINDS)

export type DocumentKind = z.infer<typeof documentKindSchema>

export const DOCUMENT_KIND_LABELS: Record<DocumentKind, string> = {
  SITE_MAP: 'Site map',
  EXAMPLE_WORK: 'Example work',
  PHOTO: 'Photo',
  CONTRACT: 'Contract',
  LOGO: 'Logo',
  OTHER: 'Other',
}
